import { forwardRef } from 'react';
import { useTexture } from '@react-three/drei';

const Caustics = forwardRef((props, ref) => {
  return (
    <mesh ref={ref} position={[0, -4.5, -5]} rotation={[-Math.PI / 2, 0, 0]}>
      <planeGeometry args={[50, 50]} />
      <meshBasicMaterial
        color="#4a9ec9"
        transparent
        opacity={0.15}
        blending={2}
      />
    </mesh>
  );
});

Caustics.displayName = 'Caustics';

export default Caustics;
